// Facility portal role codes, stored in the Parse user's `is_admin` integer
// array. All three roles currently share the same features (Service Map,
// Reservations); per-role feature limiting is deferred. Users with none of
// these codes are refused login.
export const ROLES = {
  MANAGER: 300,
  TRANSPORT_COORDINATOR: 301,
  BILLING_SPECIALIST: 302,
};

export const ALL_FACILITY_ROLES = Object.values(ROLES);

export function hasFacilityRole(isAdmin) {
  return Array.isArray(isAdmin) && isAdmin.some((code) => ALL_FACILITY_ROLES.includes(code));
}

export default ROLES;
